import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
//components
import LanguageSwitcher from 'components/navbar/LanguageSwitcher';
//images
import Errorlink from '../../assets/img/static/ico_error404_xl.png';


const NotFound = () => {
  const { t } = useTranslation(['notfound', 'header']);
  return (
    <>
      <div className="d-flex mt-3 mx-5 justify-content-end">
        <LanguageSwitcher className="lang-select-desktop" />
      </div>
      <div className="px-4 d-flex flex-column justify-content-center align-items-center static-empty ">
        <img src={Errorlink} alt="link not found" />
        <h2>{`${t('error')} 404`} </h2>
        <p className="text-center gray">{t('notavailable')}</p>
        <p className="text-center">{t('typecorrectly')}</p>
        <p className="text-center">
          {t('textaccess')}
          <Link to="/" className="ms-2">
            {t('libelist')}
          </Link>
        </p>
        <Link to="/" className="btn btn-info fit">
          {t('gobackhome')}
        </Link>
      </div>
    </>
  );
};

export default NotFound;
